import styled from 'styled-components'

const StyledNavigationBar = styled.div`
  display: flex;
  flex: auto;
  padding: 0px 30px;
  justify-content: space-between;
  border-bottom: 1px solid gray;
  background-color: white;
`

export default StyledNavigationBar
